@if (!isConnected) {
  <span class="status-badge status-badge--disconnected">Store not connected</span>
} @else if (isOnline) {
  <span class="status-badge status-badge--online">
    <span class="status-badge__dot"></span>
    Online
  </span>
} @else {
  <span class="status-badge status-badge--offline">
    <span class="status-badge__dot"></span>
    Offline
  </span>
}
